module.exports = __webpack_public_path__ + "assets/1879b233dff5f1904f9a99d2428541e9.png";